/**
 * Credential transport encoding
 *
 * Base64-encodes credentials before they leave the browser. This is transport ENCODING, not
 * encryption — it provides no confidentiality on its own; TLS does. The backend expects
 * base64-encoded password fields and decodes them server-side.
 */

/**
 * Base64-encode a credential for transport to the server.
 */
export function encodeCredential(credential: string): string {
  if (!credential) {
    return '';
  }

  try {
    return btoa(credential);
  } catch (error) {
    console.error('Error encoding credential:', error);
    return credential;
  }
}

/** @deprecated Misleading name — this is base64 encoding, not encryption. Use {@link encodeCredential}. */
export const encrypt = encodeCredential;
